'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Conversation', ['$resource',
		function ($resource) {
			return $resource(
				'/api/conversation/:id',
				{ id: '@id' },
				{
					'get': { method: 'GET' },
					'submitReply': { 
						method: 'POST', 
						url: '/api/conversation/reply'
					}
				}
			);
		}]);
